/* @flow */

type Param = {
    id: any,
    titulo: string,
    icone?: string,
    conteudo?: string,
    htmlDireita?: string
};

const accordionItem = ({
    id, titulo, icone, conteudo, htmlDireita,
}: Param) => `
<div class="m-accordion__item" data-id="${id}">
    <div
        class="m-accordion__item-head collapsed"
        role="tab"
        id="m_accordion_head_${id}"
        data-toggle="collapse"
        href="#m_accordion_body_${id}"
        aria-expanded="false">
        ${icone ? `<span class="m-accordion__item-icon"><i class="${icone}"></i></span>` : ''}
        <span class="m-accordion__item-title">${titulo}</span>
        ${conteudo ? '<span class="m-accordion__item-mode"></span>' : ''}
        ${htmlDireita || ''}
    </div>
    ${conteudo ? `
        <div
            class="m-accordion__item-body collapse"
            id="m_accordion_body_${id}"
            role="tabpanel"
            aria-labelledby="m_accordion_head_${id}">
            <div class="m-accordion__item-content">
                <p>
                    ${conteudo}
                </p>
            </div>
        </div>
    ` : ''}
</div>
`;

export default accordionItem;
